import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';

import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group.service';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';

@Component({
    selector: 'app-update-user',
    templateUrl: './update-user.component.html',
    styleUrls: ['./update-user.component.css', '../../app.component.css']
})

export class UpdateUserComponent implements OnInit, OnDestroy {
    allowed: boolean = false;
    permission: any = {};

    userForm: FormGroup;

    id: string;

    groupForm: FormGroup;

    groups = [];
    groupsInit: any;
    groupsText = '';

    selectedGroups = [];

    initials: string[] = [];

    changePassword: boolean = false;

    guSubs: Subscription;
    ggSubs: Subscription;
    initialsSub: Subscription;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: UserService,
        private groupService: GroupService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        });
        this.activatedRoute.params.subscribe(parameters => {
            
            this.id = parameters['id'];

            this.ggSubs = this.groupService.getGroups().subscribe(tempGroups => {
                this.ggSubs.unsubscribe();

                const tGroup = [];

                const dataGroup = {};

                for (let idxTg in tempGroups) {
                    tGroup[tempGroups[idxTg].id$] = tempGroups[idxTg].name;

                    dataGroup[tempGroups[idxTg].name.trim()] = null;
                    this.groups[tempGroups[idxTg].name.trim()] = tempGroups[idxTg].id$;
                }

                this.groupsInit = { 'data': dataGroup };

                this.guSubs = this.service.getUser(this.id).subscribe(({password, ...user}) => {
                    this.guSubs.unsubscribe();

                    this.userForm.patchValue(user);

                    for (let item in user.groups) {
                        this.selectedGroups.push({ groupName: tGroup[user.groups[item]], groupId: user.groups[item] });
                    }
                });
            });
        });
        this.initialsSub = service.getUsers().subscribe(users => {
            this.initials = users.filter(({id}) => id != this.id).map(({initials}) => initials);
            console.log(this.initials);
        });
    }

    ngOnInit() {
        this.userForm = this.formBuilder.group({
            name: ['', Validators.required],
            lastName: ['', Validators.required],
            initials: ['', [Validators.required, Validators.maxLength(3)]],
            email: ['', [Validators.required, Validators.email]],
            password: [''],
            confirmPassword: ['']
        });

        this.groupForm = this.formBuilder.group({
            groupId: ['', Validators.required]
        });
    }
    ngOnDestroy(): void {
        this.initialsSub.unsubscribe();
    }

    onPassword(){
        if(!this.permission.passwordEditing) return toast('Necesita permisos especiales para editar contraseñas.', 2000);
        this.changePassword = !this.changePassword;
    }

    get passwordsValid(){
        return !(this.changePassword && (!this.user.confirmPassword || !this.user.password));
    }

    onSubmitUser() {
        let {confirmPassword, ...user} = this.user;

        if(!user.groups.length) return toast('Seleccione al menos un grupo.', 3000);
        if(user.password !== confirmPassword) return toast('Las contraseñas no coinciden.', 3000);
        if(this.initials.find(initial => initial == user.initials)) return toast('Las iniciales ya pertenecen a otro usuario.', 3000);
        
        let userSub = this.service.getUserByEmail(user.email).subscribe(([userObj]) => {
            userSub.unsubscribe();
            if(!userObj || userObj.id == this.id){
                let id = this.id;
                this.service.updateUser(id, user);
                if(this.authService.currentUser.id == id){
                    let {email, groups, name, lastName, initials} = this.user;
                    this.authService.changeAUTH_USER({
                        id,
                        email,
                        groups,
                        name,
                        lastName,
                        initials
                    });
                }
            } 
            else toast('Este correo electrónico ya está registrado.', 3000);
        });
    }

    get user() {
        const groupsArray = [];

        for (let item in this.selectedGroups) {
            groupsArray.push(this.selectedGroups[item].groupId);
        }

        const userJson: any = {
            email: this.userForm.get('email').value,
            groups: groupsArray,
            lastName: this.userForm.get('lastName').value,
            name: this.userForm.get('name').value,
            initials: this.userForm.get('initials').value,
            updatedAt: new Date()
        };
        if(this.changePassword){
            userJson.password = this.userForm.get('password').value;
            userJson.confirmPassword = this.userForm.get('confirmPassword').value;
        }

        return userJson;
    }

    addGroup({ value, valid }: { value: any, valid: boolean }) {
        value.groupName = value.groupId;
        value.groupId = this.groups[value.groupId];

        if (value.groupId !== undefined) {
            if (this.selectedGroups.find(x => x.groupId === value.groupId) === undefined) {
                this.selectedGroups.push(value);
            }

            this.groupForm.reset();
        }
    }

    deleteGroup(index) {
        this.selectedGroups.splice(index, 1);
    }

    onBlurGroup() {
        console.log(this.groups, this.groupsText, this.groupsInit);
        if (this.groups[this.groupsText] === undefined) {
            this.groupsText = '';
        }
    }

}
